import React from 'react';
import { useEffect, useState } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';

import { api } from 'services/api';
import { setUser } from 'features/auth/authSlice';
import { useAppDispatch } from 'app/hooks';
import LoginPage from 'pages/Login/LoginPage';
import VacanciesPage from 'pages/Vacancies/VacanciesPage';
import VacancyPage from 'pages/Vacancy/VacancyPage';
import ApplicationDetailPage from './pages/ApplicationDetail/ApplicationDetailPage';
import CreateVacancyPage from 'pages/CreateVacancy/CreateVacancyPage';
import NotFoundPage from 'pages/NotFound/NotFoundPage';
import AdminPage from 'pages/Admin/AdminPage';

import Header from 'components/Header';

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [error, setError] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      navigate('/login');
      return;
    }

    api('auth/me')
      .then(async (res: any) => {
        const data = await res.json();
        dispatch(setUser(data));

        // перенаправлять только если пользователь пришёл с корня
        if (location.pathname === '/' || location.pathname === '/login') {
          navigate('/vacancies');
        }
      })
      .catch(() => {
        setError(true);
        navigate('/login');
      });
  }, [dispatch, navigate, location.pathname]);

  // Сбрасываем заголовок к дефолтному значению при переходе на страницу логина
  useEffect(() => {
    if (location.pathname === '/login') {
      document.title = 'Личный кабинет - Wizex';
    }
  }, [location.pathname]);

  const hideHeaderPaths = ['/login'];
  const shouldShowHeader = !hideHeaderPaths.includes(location.pathname);

  return (
    <>
      {shouldShowHeader && <Header />}
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/vacancies" element={<VacanciesPage />} />
        <Route path="/vacancies/:id" element={<VacancyPage />} />
        <Route path="/vacancies/create" element={<CreateVacancyPage />} />
        <Route path="/vacancy/:id/application/:applicationId" element={<ApplicationDetailPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

export default App;
